import { useMemo } from 'react';
import throttle from 'transmute/throttle';
import useCollaborationSidebarProps from '../../hooks/useCollaborationSidebarProps';
import useCollaborationSidebarState from '../../hooks/useCollaborationSidebarState';
import { useDeepCommentingNavigationMessaging, useSidebarMessageHandlers } from '../messaging/messageHandlers';
export const SidebarMessageHandler = () => {
  const {
    onUpdateCollaborationSidebarState,
    collaborationSidebarState
  } = useCollaborationSidebarState();
  const {
    isOpen: currentIsOpen,
    tab: currentTab
  } = collaborationSidebarState;
  const {
    onScrollToModule,
    onHighLightModuleChange,
    embeddedCommentsProps
  } = useCollaborationSidebarProps();
  const throttledOpenSidebarWithTab = useMemo(() => throttle(200, ({
    isOpen,
    tab
  }) => onUpdateCollaborationSidebarState({
    isOpen,
    tab
  })), [onUpdateCollaborationSidebarState]);
  const throttledCloseSidebar = useMemo(() => throttle(200, () => onUpdateCollaborationSidebarState({
    isOpen: false
  })), [onUpdateCollaborationSidebarState]);
  const throttledUpdateSidebarTab = useMemo(() => throttle(200, tab => onUpdateCollaborationSidebarState({
    tab
  })), [onUpdateCollaborationSidebarState]);
  useSidebarMessageHandlers({
    onRequestOpenSidebar: ({
      tab
    }) => {
      if (currentIsOpen && tab === currentTab) return;
      throttledOpenSidebarWithTab({
        isOpen: true,
        tab
      });
    },
    onRequestCloseSidebar: () => {
      if (!currentIsOpen) return;
      throttledCloseSidebar();
    },
    onRequestChangeSidebarTab: ({
      tab
    }) => {
      if (currentTab === tab) return;
      throttledUpdateSidebarTab(tab);
    }
  });
  useDeepCommentingNavigationMessaging({
    onRequestScrollToModule: msg => {
      onScrollToModule === null || onScrollToModule === void 0 || onScrollToModule(msg.payload.moduleId);
      if (msg.payload.location) {
        var _embeddedCommentsProp;
        embeddedCommentsProps === null || embeddedCommentsProps === void 0 || (_embeddedCommentsProp = embeddedCommentsProps.indicatorNavigateTo) === null || _embeddedCommentsProp === void 0 || _embeddedCommentsProp.call(embeddedCommentsProps, msg.payload.location, msg.payload.moduleId);
      }
    },
    onRequestHighlightModule: msg => {
      onHighLightModuleChange === null || onHighLightModuleChange === void 0 || onHighLightModuleChange(msg.payload.moduleId);
    }
  });
  return null;
};